import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, offeringsService } from '@v2/services';

export const useRemoveBitwerxSubOffering = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: offeringsService.removeBitwerxSubOffering,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.offerings.bitwerx.all);
    },
  });

  const removeBitwerxSubOffering = async (
    subOfferingId: string
  ): Promise<string | null> => {
    if (!subOfferingId?.trim()) return null;
    try {
      return await mutation.mutateAsync(subOfferingId);
    } catch {
      return null;
    }
  };

  return {
    removeBitwerxSubOffering,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useRemoveBitwerxSubOffering;
